import ProductBrandPanel from './productBrand.container';

export default ProductBrandPanel;